import { render, staticRenderFns } from "./CodeTemplate.vue?vue&type=template&id=c5a9cbf4&scoped=true"
import script from "./CodeTemplate.vue?vue&type=script&lang=js"
export * from "./CodeTemplate.vue?vue&type=script&lang=js"
import style0 from "./CodeTemplate.vue?vue&type=style&index=0&id=c5a9cbf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a9cbf4",
  null
  
)

export default component.exports